import { apiClient, APIResponse } from './client';

export interface PackageUsageLimit {
  limit: number;
  current: number;
  unlimited: boolean;
  canCreate?: boolean;
  canInvite?: boolean;
}

export interface PackageUsageData {
  subscription: {
    packageName: string;
    packageCode: string;
    packageType: string;
    validUpto: string;
    status: string;
  } | null;
  limits: {
    scans: PackageUsageLimit;
    projects: PackageUsageLimit;
    applications: PackageUsageLimit;
    teamMembers: PackageUsageLimit;
    ortUploads: PackageUsageLimit;
  };
  features: Record<string, any>;
}

export interface PackageValidationResult {
  canCreate?: boolean;
  canInvite?: boolean;
  message?: string;
  currentUsage?: number;
  limit?: number;
}

/** Same shape as EffectivePermission (client/src/api/profile.ts), for the workgroup's current package instead of the caller's role. */
export interface EntitlementGrant {
  modulecode: string;
  actions: string[];
}

export interface EntitlementsData {
  packageCode: string | null;
  packageTitle: string | null;
  entitlements: EntitlementGrant[];
}

export class PackageLimitsAPI {
  static async getPackageUsage(): Promise<APIResponse<PackageUsageData>> {
    return apiClient.get<PackageUsageData>('/package-limits/usage');
  }

  static async getEntitlements(): Promise<APIResponse<EntitlementsData>> {
    return apiClient.get<EntitlementsData>('/package-limits/entitlements');
  }

  static async validateScanCreation(): Promise<APIResponse<PackageValidationResult>> {
    return apiClient.get<PackageValidationResult>('/package-limits/scans/validate');
  }

  static async validateProjectCreation(): Promise<APIResponse<PackageValidationResult>> {
    return apiClient.get<PackageValidationResult>('/package-limits/projects/validate');
  }

  static async validateApplicationCreation(): Promise<APIResponse<PackageValidationResult>> {
    return apiClient.get<PackageValidationResult>('/package-limits/applications/validate');
  }

  static async validateTeamMemberInvitation(): Promise<APIResponse<PackageValidationResult>> {
    return apiClient.get<PackageValidationResult>('/package-limits/team-members/validate');
  }

  static async validateOrtUploadCreation(): Promise<APIResponse<PackageValidationResult>> {
    return apiClient.get<PackageValidationResult>('/package-limits/ort-uploads/validate');
  }
}
